import { Injectable } from '@angular/core';
import { ValidationResult } from '../models/validation-result.model';

@Injectable({
    providedIn: 'root'
})
export class MailValidatorService {

    private mailRegexPattern  : RegExp = /^[A-Za-z0-9._-]+[@]{1}[A-Za-z0-9._-]+[.]{1}[A-Za-z0-9._-]{2,6}$/;
    private formatErrorMessage: string = 'El formato del mail es incorrecto';

    constructor() { }

    public validate(mail: string) : ValidationResult {

        let result = new ValidationResult();

        // Converts to lowercase.
        mail = mail?.toLowerCase();

        // Checks format.
        if (!this.mailRegexPattern.test(mail)) {

            result.setInvalidResult(this.formatErrorMessage);
            return result;

        }

        result.setValidResult();
        return result;

    }

}
